// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { CreateContactParameters, contactSchema } from '@/contact/api/types';
import { z } from 'zod';

const createContactResponseSchema = z
  .object({
    data: contactSchema,
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({ ...response, contact: data }));

type CreateContactResponse = z.infer<typeof createContactResponseSchema>;

export async function createContact(
  parameters: CreateContactParameters
): Promise<CreateContactResponse> {
  const url = '/v1/contact';
  const response = await api.post(url, parameters);

  return parseResponse(createContactResponseSchema, response.data, {
    schemaName: 'CreateContact',
    endpoint: url,
  });
}
